export enum ModuleQuestionType {
	CAREER_STEP_REALIZATIONS = 'CAREER_STEP_REALIZATIONS', // CAREER_STEP_REALIZATIONS
	CAREER_STEP_DETAIL = 'CAREER_STEP_DETAIL', // CAREER_STEP_DETAIL
	CAREER_STEP = 'CAREER_STEP', // CAREER_STEP
	CERTIFICATE = 'CERTIFICATE', // CERTIFICATE
	VOLUNTEER = 'VOLUNTEER', // VOLUNTEER
	DIPLOMA = 'DIPLOMA', // DIPLOMA
	CONTACT = 'CONTACT', // CONTACT
	GENERIC = 'GENERIC', // GENERIC
	FILE = 'FILE', // FILE
}
